import { render, staticRenderFns } from "./CurrentActionEFatura.vue?vue&type=template&id=7c3f4510&scoped=true"
import script from "./CurrentActionEFatura.vue?vue&type=script&lang=js"
export * from "./CurrentActionEFatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f4510",
  null
  
)

export default component.exports